import firebase from "firebase/app";
import { imageDatabaseCollection } from "@/firebase";
import { storage } from "@/firebase";

const state = {
  imageDatabase: [],
  firstQuery: "",
  lastQuery: "",
  page: 1,
  pageSize: 30,
  search: "",
  last: 99999999,
  category: "/",
  lang: "all",
  order: "popular"
};

const getters = {};

const actions = {
  getImageDatabase({ commit }, payload) {
    //console.log(state);
    return new Promise((resolve, reject) => {
      if (payload.mode == "live") {
        //*
        // MODE: LIVE
        //*
        if (state.lang == "all") {
          if (state.order == "add") {
            //
            // ORDER BY ADD
            //
            console.log("order by add");
            if (state.category == "/" && (state.search.length <= 0 || state.search == null)) {
              // iskanje neaktivno
              console.log("iskanje neaktivno");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category == "/") {
              // iskalni niz
              console.log("iskalni niz");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category != "/") {
              // search and category filter
              console.log("search and category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else {
              // category filter
              console.log("category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            }
          } else {
            //
            // ORDER BY POPULAR
            //
            console.log("order by popular");
            if (state.category == "/" && (state.search.length <= 0 || state.search == null)) {
              // iskanje neaktivno
              console.log("iskanje neaktivno");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category == "/") {
              // iskalni niz
              console.log("iskalni niz");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category != "/") {
              // search and category filter
              console.log("search and category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else {
              // category filter
              console.log("category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            }
          }
        } else {
          if (state.order == "add") {
            //
            // ORDER BY ADD
            //
            console.log("order by add");
            if (state.category == "/" && (state.search.length <= 0 || state.search == null)) {
              // iskanje neaktivno
              console.log("iskanje neaktivno");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category == "/") {
              // iskalni niz
              console.log("iskalni niz");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category != "/") {
              // search and category filter
              console.log("search and category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else {
              // category filter
              console.log("category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("editedTimestamp", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            }
          } else {
            //
            // ORDER BY POPULAR
            //
            console.log("order by popular");
            if (state.category == "/" && (state.search.length <= 0 || state.search == null)) {
              // iskanje neaktivno
              console.log("iskanje neaktivno");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category == "/") {
              // iskalni niz
              console.log("iskalni niz");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else if (state.search.length > 0 && state.category != "/") {
              // search and category filter
              console.log("search and category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("keywords", "array-contains", state.search)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            } else {
              // category filter
              console.log("category filter");
              if (state.firstQuery == "") {
                console.log("getFirst");
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "refresh") {
                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAt(state.firstQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Error getting documents: ", error));
                  });
              } else if (payload.refresh == "getNext") {
                console.log("getNext");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .startAfter(state.lastQuery)
                  .limit(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      console.log("getNext => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", 1);

                      let tempData = [];
                      querySnapshot.forEach((doc) => {
                        tempData.push(Object.assign(doc.data(), { id: doc.id }));
                      });
                      resolve(commit("getImageDatabase", tempData));
                    } else {
                      console.log("getNext => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setLastPage", state.page);
                      resolve(commit("setConstPage", state.page));
                    }
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              } else if (payload.refresh == "getPrevious") {
                console.log("getPrevious");
                let tempFirstQuery = state.firstQuery;
                let tempLastQuery = state.lastQuery;

                imageDatabaseCollection
                  .where("client", "in", ['/', payload.client])
                  .where("type", "==", payload.type)
                  .where("active", "==", true)
                  .where("language", "==", state.lang)
                  .where("category", "==", state.category)
                  .orderBy("order", "asc")
                  .orderBy("counter", "desc")
                  .endBefore(state.firstQuery)
                  .limitToLast(state.pageSize)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty && state.page > 1) {
                      console.log("getPrevious => full");
                      console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                      console.log("firstQuery", querySnapshot.docs[0].data().title);
                      commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                      commit("getFirstQuery", querySnapshot.docs[0]);
                      commit("setPage", -1);
                    } else {
                      console.log("getPrevious => empty");
                      commit("getLastQuery", tempLastQuery);
                      commit("getFirstQuery", tempFirstQuery);
                      commit("setConstPage", 1);
                    }

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  })
                  .catch(function (error) {
                    reject(console.log("Errsor getting documents: ", error));
                  });
              }
            }
          }
        }
      } else {
        //*
        // MODE: EDIT
        //*
        if (state.order == "add") {
          //
          // ORDER BY ADD
          //          
          if (state.category == "/" && state.search == "") {
            // no filters            
            if (state.firstQuery == "") {
              console.log("edit / add / no filters / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / add / no filters / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / add / no filters / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / add / no filters / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          } else if (state.category == "/" && state.search != "") {
            // search filter            
            if (state.firstQuery == "") {
              console.log("edit / add / search / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / add / search / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / add / search / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / add / search / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          } else if (state.category != "/" && state.search != "") {
            // search and category filter            
            if (state.firstQuery == "") {
              console.log("edit / add / search & category / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / add / search & category / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / add / search & category / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / add / search & category / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          } else if (state.category != "/" && state.search == "") {
            // category filter            
            if (state.firstQuery == "") {
              console.log("edit / add / category / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / add / category / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / add / category / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / add / category / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("editedTimestamp", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          }
        } else {
          //
          // ORDER BY POPULARITY
          //          
          if (state.category == "/" && state.search == "") {
            // iskanje neaktivno          
            if (state.firstQuery == "") {
              console.log("edit / popular / no filters / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / popular / no filters / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / popular / no filters / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / popular / no filters / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          } else if (state.category == "/" && state.search != "") {
            // iskalni niz            
            if (state.firstQuery == "") {
              console.log("edit / popular / search / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / popular / search / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / popular / search / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / popular / search / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          } else if (state.category != "/" && state.search != "") {
            // search and category filter            
            if (state.firstQuery == "") {
              console.log("edit / popular / search & category / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / popular / search & category / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / popular / search & category / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / popular / search & category / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("keywords", "array-contains", state.search)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          } else if (state.category != "/" && state.search == "") {
            // category filter            
            if (state.firstQuery == "") {
              console.log("edit / popular / category / getFirst");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "refresh") {
              console.log("edit / popular / category / refresh");
              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAt(state.firstQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Error getting documents: ", error));
                });
            } else if (payload.refresh == "getNext") {
              console.log("edit / popular / category / getNext");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .startAfter(state.lastQuery)
                .limit(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    console.log("getNext => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", 1);

                    let tempData = [];
                    querySnapshot.forEach((doc) => {
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                    });
                    resolve(commit("getImageDatabase", tempData));
                  } else {
                    console.log("getNext => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setLastPage", state.page);
                    resolve(commit("setConstPage", state.page));
                  }
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            } else if (payload.refresh == "getPrevious") {
              console.log("edit / popular / category / getPrevious");
              let tempFirstQuery = state.firstQuery;
              let tempLastQuery = state.lastQuery;

              imageDatabaseCollection
                .where("client", "in", ['/', payload.client])
                .where("type", "==", payload.type)
                .where("category", "==", state.category)
                .orderBy("order", "asc")
                .orderBy("counter", "desc")
                .endBefore(state.firstQuery)
                .limitToLast(state.pageSize)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty && state.page > 1) {
                    console.log("getPrevious => full");
                    console.log("lastQuery", querySnapshot.docs[querySnapshot.docs.length - 1].data().title);
                    console.log("firstQuery", querySnapshot.docs[0].data().title);
                    commit("getLastQuery", querySnapshot.docs[querySnapshot.docs.length - 1]);
                    commit("getFirstQuery", querySnapshot.docs[0]);
                    commit("setPage", -1);
                  } else {
                    console.log("getPrevious => empty");
                    commit("getLastQuery", tempLastQuery);
                    commit("getFirstQuery", tempFirstQuery);
                    commit("setConstPage", 1);
                  }

                  let tempData = [];
                  querySnapshot.forEach((doc) => {
                    tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  });
                  resolve(commit("getImageDatabase", tempData));
                })
                .catch(function (error) {
                  reject(console.log("Errsor getting documents: ", error));
                });
            }
          }
        }
      }
    });
  },
  addImageDatabase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      imageDatabaseCollection
        .add(payload)
        .then(() => {
          // dodamo brez auto id-ja, ker sicer jih vnese narobe in so duplicated, ne vem zakaj
          commit(
            "addImageDatabase",
            payload
          )
          resolve(
            { success: true, payload: payload }
          );
        }).catch((error) => {
          console.log(error);
          reject({ success: false, payload: payload });
        });
    });
  },

  // eslint-disable-next-line
  editImageDatabase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      // če keywords popravimo v edit dialogu, postane string, sicer ostane array
      if (!Array.isArray(payload.keywords)) {
        payload.keywords = payload.keywords.toLowerCase();
        payload.keywords = payload.keywords.split(","); // String => Array
      }

      payload.editedTimestamp = firebase.firestore.Timestamp.fromDate(
        new Date()
      );

      if (payload.image == undefined) {
        payload.image = payload.image2;
        delete payload.image2;

        imageDatabaseCollection
          .doc(payload.id)
          .set(payload, { merge: true })
          .then(() => {
            resolve(commit("editImageDatabase", payload));
          })
          .catch((error) => {
            reject(console.log(error));
          });
      } else {
        let uploadPath = payload.imageURL;
        //let uploadPathPreview = payload.imagePreviewURL;

        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                delete payload.image2;

                // preview image upload      
                let uploadTask2 = storage.ref(uploadPath + "-p").putString(payload.imagePreview, "base64", { contentType: "image/ jpg" });
                uploadTask2.on(firebase.storage.TaskEvent.STATE_CHANGED, {
                  complete: function () {
                    uploadTask2.snapshot.ref
                      .getDownloadURL()
                      .then(function (downloadURL2) {
                        payload.imagePreview = downloadURL2;

                        imageDatabaseCollection
                          .doc(payload.id)
                          .set(payload, { merge: true })
                          .then(() => {
                            resolve(commit("editImageDatabase", payload));
                          })
                          .catch((error) => {
                            reject(console.log(error));
                          });
                      }).catch((error) => {
                        reject(console.log(error));
                      });
                  }
                });
              });
          },
        });
      }
    });
  },

  removeImageDatabase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      imageDatabaseCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeImageDatabase", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },

  // eslint-disable-next-line
  saveFrameDimensions({ commit }, payload) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      imageDatabaseCollection
        .doc(payload.id)
        .update({
          coordinates: payload.coordinates,
        })
        .then(() => {
          console.log("Edited record.");
          resolve();
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  imageDatabaseSetInitState(state, payload) {
    state.firstQuery = payload.firstQuery;
    state.lastQuery = payload.lastQuery;
    state.page = payload.page;
    state.last = payload.last;
    state.search = payload.search;
  },
  imageDatabaseSetInitState2(state, payload) {
    state.firstQuery = payload.firstQuery;
    state.lastQuery = payload.lastQuery;
    state.page = payload.page;
    state.last = payload.last;
    state.category = payload.category;
  },
  imageDatabaseSetAll(state, payload) {
    state.firstQuery = payload.firstQuery;
    state.lastQuery = payload.lastQuery;
    state.page = payload.page;
    state.last = payload.last;
    state.search = payload.search;
    state.category = payload.category;
    state.lang = payload.lang;
    //console.log("imageDatabaseSetAll", state);
  },
  setPage(state, payload) {
    state.page += payload;
    //console.log(state.page);
  },
  setLastPage(state, payload) {
    state.last = payload;
  },
  setConstPage(state, payload) {
    state.page = payload;
  },
  getLastQuery(state, payload) {
    state.lastQuery = payload;
    //console.log(state.lastQuery);
  },
  getFirstQuery(state, payload) {
    state.firstQuery = payload;
    //console.log(state.firstQuery);
  },
  getImageDatabase(state, payload) {
    state.imageDatabase = payload;
    //console.log(state.imageDatabase);
  },
  addImageDatabase(state, payload) {
    state.imageDatabase.push(payload);
  },
  removeImageDatabase(state, payload) {
    const index = state.imageDatabase.findIndex((item) => item.id == payload);
    state.imageDatabase.splice(index, 1);
  },
  editImageDatabase(state, payload) {
    const index = state.imageDatabase.findIndex((item) => item.id == payload.id);
    state.imageDatabase.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
